var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status === 0)?_c('span',{attrs:{"title":"Crédits pappers épuisés "}},[_c('i',{staticClass:"fa-fw fas fa-exclamation-triangle text-danger"})]):_vm._e(),_vm._v(" "),(_vm.displayIntro)?_c('span',[_vm._v("\n        "+_vm._s(_vm.introduction)+"\n    ")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.update)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }